
// NOTE: this button doesn't emit anything. It's here just to enable emitting an 'on property change' action
// We can expand it to support other actions, but right now I only need onPropertyChange
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import NiceButton from "@/components/UI/NiceButton.vue";
import { ControlOptions } from "@/types/controls";
import { breakdanceStoreActions } from "@/store/actions/store-actions";
import { uiStore } from "@/store/store-accessor";
@Component({
  components: { NiceButton }
})
export default class TriggerActionButton extends Vue {
  @Prop({
    default: () => ({ text: "Click" })
  })
  options!: ControlOptions["triggerActionsButtonOptions"];

  @Prop()
  path!: string;

  triggerOnPropertyChangeAction() {
    if (!uiStore.activeElementId) {
      return;
    }

    breakdanceStoreActions.run.onPropertyChange({
      elementId: uiStore.activeElementId,
      path: this.path,
      value: "",
      previousValue: "",
      transactionKey: undefined
    });
  }
}
